import { render, staticRenderFns } from "./NotesScrollList.vue?vue&type=template&id=2cff5ff2"
import script from "./NotesScrollList.js?vue&type=script&lang=js&external"
export * from "./NotesScrollList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports